export { AffiliatedCompaniesTable } from './AffiliatedCompaniesTable'
export { CompanyAdverseMediaCaseTable } from './CompanyAdverseMediaCaseTable'
export { CompanyAnnualReviewTable } from './CompanyAnnualReviewTable'
export { CompanyBankAccountsTable } from './CompanyBankAccountsTable'
export { CompanyContactsTable } from './CompanyContactsTable'
export { CompanyCustomersTable } from './CompanyCustomersTable'
export { CompanyDocumentsTable } from './CompanyDocumentsTable'
export { CompanyHistoryTable } from './CompanyHistory'
export { CompanyLicensesTable } from './CompanyLicensesTable'
export { CompanyQRsTable } from './CompanyQRsTable'
export { CompanyVendorsTable } from './CompanyVendorsTable'
export { GeneralInformation } from './GeneralInformation'
export { HighRiskReview } from './HighRiskReview'
